<!-- 规则弹窗 -->
<template>
  <div class="rule-popup">
    <van-overlay :show="show" @click="close" :lock-scroll="false">
      <div class="wrapper" @click.stop>
        <p class="text1">活动规则</p>
        <p class="text2">{{ ruleStr }}</p>
        <div>
          <p style="line-height: 1.5">下滑动查看更多↓</p>
          <div class="btn" @click="close">
            <span>知道了</span>
          </div>
        </div>
      </div>
      <!-- <img
        class="close"
        @click="close"
        :src="
          require(`@/assets/imgs/jiangsuXingyeDigitalCoinLottery/close.png`)
        "
        alt=""
      /> -->
    </van-overlay>
  </div>
</template>
<script>
import { Toast } from 'vant'
export default {
  components: {},
  props: ['prize', 'isDemo'],
  data() {
    return {
      show: false,
      ruleStr: `一:活动时间：
      2025年1月1日至2025年6月30日； 
二:活动对象：
江苏省（除苏州市）地区兴业银行数字人民币三类及以上钱包用户；
三:活动内容 
1.活动期间，活动对象进入活动并完成授权手机号码，使用兴业银行数字人民币支付一分钱后即可参加活动；
2.活动对象根据页面提示，通过微信绑定“兴业银行数字人民币钱包”支付0.01元即可获得一次抽奖机会，随机抽取0.88元~188元数币消费红包一份； 
3.活动期间同一客户每月可参与1次活动，同一身份证、同一微信账户、同一钱包账户、同一手机号、同一终端设备，满足其中任意条件都视为同一用户； 
4.每月活动奖品数量有限，发完即止，先到先得。 
四:其他细则 
1.通过本次活动获得的所有数字人民币红包，限兴业银行三类及以上数币钱包客户核销使用，自获得之日起7日内有效，逾期未使用将视为自动放弃；
2.数币消费红包在所有数币支付功能的商户均可使用，使用数币钱包消费即可抵扣；
3.若客户使用的数币红包产生的钱包交易因故发生了退款的情况，原本交易时抵用的红包将退回到钱包账户，如使用有效期不变，退还的红包在原有效期内可继续使用;如退还的数币红包在原有效期外，则不支持再次使用； 
4.若用户存在通过不正当手段获取不当利益或有碍其他用户公平参加活动或有违活动举办目的的记录或行为，活动方有权取消该用户活动参与资格或取消、追回该用户通过参加活动所获奖品或权益；
5.本次活动由易点生活电子商务有限公司收集用户信息，具体包括头像、昵称、openid、手机号、地理位置；
6.如有疑问，可致电客服电话咨询客服电话:400-662-7299(每周一至周五9-12点、14-18点，节假日除外) 
`
    }
  },
  computed: {
    title() {
      let res = ``
      let prize = this.$filters.moneyNoFixedFilter(this.prize.couponAmount) || 0
      res = `获得<span style="color: #FF5959;">${prize}</span>元数币红包`
      return res
    },
  },
  methods: {
    close() {
      this.setShow(false)
      this.$emit('ruleClose')
    },
    setShow(val) {
      this.show = val
    },
  },
}
</script>
<style lang="less" scoped>
.rule-popup {
  position: relative;
  text-align: center;

  .wrapper {
    margin: 15% 20px 20px 20px;
    background: #3f92e3;
    border-radius: 51px;
    border: 11px solid #fffeff;
    text-align: center;
    text-align: center;
    overflow: auto;
    .text1 {
      padding: 30px 0 10px 0;
      font-weight: bold;
      font-size: 24px;
      color: #000000;
      text-shadow: #ffffff 1px 0 0, #ffffff 0 1px 0, #ffffff -1px 0 0,
        #ffffff 0 -1px 0;
    }
    .text2 {
      padding: 20px 20px;
      font-size: 12px;
      color: #ffffff;
      line-height: 1.5;
      text-align: left;
      white-space: pre-wrap;
      text-align: justify;
      max-height: 53vh;
      overflow: auto;
    }
    .btn {
      border: 3px solid #fff;
      border-radius: 30px;
      margin: 10px auto 20px auto;
      width: 160px;
      span {
        display: block;
        line-height: 2.5;
        border-radius: 30px;
        border: 3px solid #000;
        background: #ffffff;
        font-size: 21px;
        font-weight: 600;
        color: #000000;
      }
    }
  }
  .close {
    width: 35px;
  }
}
</style>
